import { PRODUCT_CARD_CAROUSEL_CHANGE } from './productCardCarouselChange';
import { PRODUCT_CARD_CAROUSEL_ARROW_CLICK } from './productCardCarouselArrowClick';
import { PRODUCT_CARD_CAROUSEL_UPDATE } from './productCardCarouselUpdate';
import { YOTPO_INIT } from './yotpoInit';
import { EMAIL_UNSUBSCRIBE } from './emailUnsubscribe';
import { CUSTOMER_ACTIVATE } from './customerActivate';
import { MINICART_OPEN } from './minicartOpen';
import { MINICART_CHECKOUT_CLICK } from './minicartCheckoutClick';
import { BUCKET_ASSIGN } from './bucketAssign';
// Event names are derived from the keys in EventMap and should follow
// the Noun-Verb convention to make it easier to identify all events related to a given noun.
// Combination event nouns should be ordered from least-to-most specificity.
// Example: "CART_ADD" instead of "ADD_TO_CART".
export var EventMap = {
    YOTPO_INIT: YOTPO_INIT,
    EMAIL_UNSUBSCRIBE: EMAIL_UNSUBSCRIBE,
    CUSTOMER_ACTIVATE: CUSTOMER_ACTIVATE,
    PRODUCT_CARD_CAROUSEL_CHANGE: PRODUCT_CARD_CAROUSEL_CHANGE,
    PRODUCT_CARD_CAROUSEL_ARROW_CLICK: PRODUCT_CARD_CAROUSEL_ARROW_CLICK,
    PRODUCT_CARD_CAROUSEL_UPDATE: PRODUCT_CARD_CAROUSEL_UPDATE,
    MINICART_OPEN: MINICART_OPEN,
    MINICART_CHECKOUT_CLICK: MINICART_CHECKOUT_CLICK,
    BUCKET_ASSIGN: BUCKET_ASSIGN
};
